export default __webpack_public_path__ + "static/media/zuppler.30bfcfad.svg";